import { DynamicFormV2Palette } from "@mui/material";

export type FormDateSelectFieldComponentTokenType = {
  labelTextColor: string;
  labelBackgroundColor: string;
  inputContainerBorderColor: string;
};

export const assignDateSelectFieldComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark"
) => {
  const isLightMode = mode === "light";

  return {
    labelTextColor: formsPalette.text.reverse,
    labelBackgroundColor: isLightMode ? formsPalette.surface.intense : formsPalette.surface.reverse,
    inputContainerBorderColor: formsPalette.border.brand,
  } as FormDateSelectFieldComponentTokenType;
};
